import { useState, useEffect } from "react";
import { Shield } from "lucide-react";

const PASS_KEY = "mendrx_access";
const ACCESS_CODE = "MENDRx2026";

export default function PasswordGate({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem(PASS_KEY) === "granted") {
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === ACCESS_CODE) {
      sessionStorage.setItem(PASS_KEY, "granted");
      setAuthenticated(true);
      setError(false);
    } else {
      setError(true);
      setInput("");
    }
  };

  if (loading) return null;
  if (authenticated) return children;

  return (
    <div className="gate-container" data-testid="password-gate">
      <div className="gate-card">
        <div className="gate-icon">
          <Shield size={36} />
        </div>
        <h1 className="gate-title">MENDRx</h1>
        <p className="gate-subtitle">Strategic Report Hub</p>
        <p className="gate-label">Enter access code to continue</p>
        <form onSubmit={handleSubmit} className="gate-form">
          <input
            type="password"
            value={input}
            onChange={(e) => { setInput(e.target.value); setError(false); }}
            placeholder="Access code"
            className={`gate-input ${error ? "gate-input-error" : ""}`}
            autoFocus
            data-testid="password-input"
          />
          <button type="submit" className="gate-button" data-testid="password-submit">
            Enter
          </button>
        </form>
        {error && <p className="gate-error" data-testid="password-error">Invalid access code</p>}
        <p className="gate-footer">CONFIDENTIAL</p>
      </div>
    </div>
  );
}
